import Chip from '@mui/material/Chip';
import { SxProps, Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';

import { getContrastTextColor } from '~utils/colors';

interface LabelChipProps {
  color: string;
  disableTooltip?: boolean;
  name: string;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
}

export default function LabelChip({
  color,
  disableTooltip = false,
  name,
  size = 'small',
  sx,
}: LabelChipProps) {
  const textColor = getContrastTextColor(color);
  const chip = (
    <Chip
      label={name}
      size={size}
      sx={[
        {
          bgcolor: color,
          color: textColor,
          '& .MuiChip-label': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );

  if (disableTooltip) {
    return chip;
  }

  return <Tooltip title={name}>{chip}</Tooltip>;
}
